import { reportHandledBrowserError } from '@/monitoring/browserErrors'
import { USER_SESSION_STORAGE_KEY } from "@/store/userSessionStorage"

const STORAGE_KEY = "bsedu:temporaryDocuments"
const scopes = ["interview", "simulator"]

function readDocuments() {
  try {
    const data = JSON.parse(sessionStorage.getItem(STORAGE_KEY))
    return data?.version === 1 && typeof data.owner === "string" ? data : null
  } catch {
    return null
  }
}

export function clearTemporaryDocuments() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // 저장소 접근이 차단된 환경에서도 로그아웃은 계속 진행합니다.
  }
}

export function syncTemporaryDocumentOwner(userId) {
  if (!userId || readDocuments()?.owner !== String(userId)) clearTemporaryDocuments()
}

export function saveTemporaryDocuments(userId, scope, documents) {
  if (!userId || !scopes.includes(scope)) throw new Error("로그인 후 임시 저장해 주세요.")
  const previous = readDocuments()
  const data = previous?.owner === String(userId)
    ? previous
    : { version: 1, owner: String(userId) }
  data[scope] = documents
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch {
    const failure = new Error("임시 저장에 실패했습니다. 브라우저 저장 공간과 설정을 확인해 주세요.")
    reportHandledBrowserError(failure, "temporary_document_save")
    throw failure
  }
}

export function loadTemporaryDocument(userId, scope, docIndex = "1") {
  const data = readDocuments()
  if (!userId || data?.owner !== String(userId) || !scopes.includes(scope)) return null
  if (!Array.isArray(data[scope])) return null
  const doc = data[scope].find(item => item && String(item.docIndex || "1") === String(docIndex))
  if (!doc || typeof doc !== "object") return null
  const textFields = ["hope_univ", "hope_depart", "free_activity", "career_activity",
    "subject_skill_detail", "behavior_characteristics"]
  if (textFields.some(key => doc[key] != null && typeof doc[key] !== "string")) return null
  for (const key of ["club_activity", "volunteer_activity"]) {
    if (!Array.isArray(doc[key]) || doc[key].some(item => !item || typeof item !== "object" || Array.isArray(item))) return null
  }
  return doc
}

export function handleDocumentSessionChange(event) {
  if (event.storageArea !== localStorage) return
  if (event.key === null) {
    clearTemporaryDocuments()
    return
  }
  if (event.key !== USER_SESSION_STORAGE_KEY) return
  try {
    const previous = JSON.parse(event.oldValue)?.user?.userId
    const current = JSON.parse(event.newValue)?.user?.userId
    if (!current || String(previous) !== String(current)) clearTemporaryDocuments()
  } catch {
    clearTemporaryDocuments()
  }
}
